import { render } from "./ContactMe.vue?vue&type=template&id=bcd7ff74&scoped=true"
import script from "./ContactMe.vue?vue&type=script&lang=js"
export * from "./ContactMe.vue?vue&type=script&lang=js"

import "./ContactMe.vue?vue&type=style&index=0&id=bcd7ff74&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd7ff74"]])

export default __exports__